$(function (ws) {
    'use strict';

    ws.views.orderHistory = Backbone.View.extend({
        /**
         * Initialize the component.
         */
        initialize() {
            this.url = '';
            this.isLoaded = false;
            this.noBeforeValue = this.$('.comp-data-table').data('noBeforeValue');
            this.noAfterValue = this.$('.comp-data-table').data('noBeforeValue');
            this.operation = this.$('.comp-data-table').data('noBeforeValue');
            this.eventAgg.on('tab-history', this.showHistory.bind(this));
            this.columns = [];
        },

        /**
         * Fetches the history and displays it on the page.
         */
        showHistory(e) {
            if (isOrderEntrySite) {
                this.url = globals.path.api.orderentry.orderDetails.history.replace('{orderId}', $('.order-meta-data').data('orderNumber'));
                this.columns = [
                    { data: 'button', class: 'details-control' },
                    { data: 'displayLineNumber'},
                    { data: 'date' },
                    { data: 'time' },
                    { data: 'user' },
                    { data: 'modificationType' },
                    { data: 'attributeDisplayName' },
                    { data: 'beforeValue', render: function(data, type, row, meta) {
                        return _.escape(data);
                    }
                    },
                    { data: 'afterValue', render: function(data, type, row, meta) {
                            return _.escape(data);
                        }
                    }
                ];
            } else if (isQuotingSite) {
                this.url = globals.path.api.quoting.historyQuote.replace('{quoteId}', $('.quoteID').val()) + '&' + CSRF;
                this.columns = [
                    { data: 'button', class: 'details-control' },
                    { data: 'displayLineNumber'},
                    { data: 'date' },
                    { data: 'time' },
                    { data: 'user' },
                    { data: 'modificationType' },
                    { data: 'attributeDisplayName' },
                    { data: 'beforeValue', render: function(data, type, row, meta) {
                            return _.escape(data);
                        }
                    },
                    { data: 'afterValue', render: function(data, type, row, meta) {
                            return _.escape(data);
                        }
                    }
                ];
            } else {
                this.url = globals.path.api.westcon.history.replace('{customerId}', $('#prospectId').val());
                this.columns = [
                    { data: 'button', class: 'details-control' },
                    { data: 'date' },
                    { data: 'time' },
                    { data: 'user' },
                    { data: 'modificationType' },
                    { data: 'operation'},
                    { data: 'attributeDisplayName' },
                    { data: 'beforeValue', render: function(data, type, row, meta) {
                            return _.escape(data);
                        }
                    },
                    { data: 'afterValue', render: function(data, type, row, meta) {
                            return _.escape(data);
                        }
                    }
                ];
            }

            //Only load the history once
            if (this.isLoaded && (isOrderEntrySite || isQuotingSite)) {
                return;
            }

            globals.disableApp();

            // Generate the DataTable
            let dataTableOptions = {
                bFilter: false,
                bLengthChange: false,
                ordering: false,
                processing: false,
                serverSide: true,
                ajax: {
                    url: this.url,
                    dataSrc: 'data'
                },
                columns: this.columns,
                createdRow: this.onDataTableCreateRow.bind(this),
                drawCallback: this.onDataTableDraw.bind(this)
            };

            if (e && this.$dataTable) {
                this.$dataTable.ajax.reload();
            } else {
                this.$dataTable = this.$('.comp-data-table > table')
                    .on('xhr.dt', this.onDataTableAjax.bind(this)).DataTable(dataTableOptions);
            }
        },

        /**
         * Prepares the data for consumption by DataTables
         * after it is received from the server.
         * Modifications are made directly to the json object,
         * which are then used in other DataTables functions.
         *
         * After this function runs, ALL json.data records will have at least the following properties:
         *
         * - {bool} isChild
         * - {bool} isOdd
         * - {number} parentRowId
         * - {string} button
         * - {string} date
         * - {string} time
         * - {string} user
         * - {string} modificationType
         * - {string} attributeDisplayName
         * - {string} beforeValue
         * - {string} afterValue
         *
         * @param {Event} e
         * @param {Object} settings
         * @param {Object} json - The JSON to get back from the server
         * @param {Array} json.data - The array of parent rows
         * @param {string} json.data[].date - The date of a parent row
         * @param {string} json.data[].time - The time of a parent row
         * @param {string} json.data[].user - The user of a parent row
         * @param {Array} json.data[].entries - The child rows of a parent row
         * @param {string} json.data[].entries[].attributeDisplayName - The display name of a child row's attribute
         * @param {string} json.data[].entries[].beforeValue - The value of a child row's attribute before editing
         * @param {string} json.data[].entries[].afterValue - The value of a child row's attribute after editing
         */
        onDataTableAjax(e, settings, json) {
            if (json && !_.isArray(json.data)) {
                json.data = [];
            }

            const parentRowCount = json ? json.data.length : 0;
            for (let i = 0, currentRowIndex = 0; i < parentRowCount; i++, currentRowIndex++) {
                const parentRowIndex = currentRowIndex;
                $.extend(json.data[parentRowIndex], {
                    isChild: false,
                    parentRowId: i,
                    isOdd: i % 2 === 1,
                    button: '<button class="expand-collapse">+</button>',
                    operation: '',
                    attributeDisplayName: '',
                    beforeValue: '',
                    afterValue: ''
                });
                if (json.data[parentRowIndex].entries && (isOrderEntrySite || isQuotingSite)) {
                    for (let j = 0; j < json.data[parentRowIndex].entries.length; j++, currentRowIndex++) {
                        const childRow = {
                            isChild: true,
                            parentRowId: i,
                            isOdd: j % 2 === 1,
                            button: null,
                            displayLineNumber: json.data[parentRowIndex].displayLineNumber,
                            date: json.data[parentRowIndex].date,
                            time: json.data[parentRowIndex].time,
                            user: json.data[parentRowIndex].user,
                            modificationType: '',
                            attributeDisplayName: json.data[parentRowIndex].entries[j].attributeDisplayName,
                            beforeValue: (json.data[parentRowIndex].entries[j].beforeValue ? json.data[parentRowIndex].entries[j].beforeValue : (this.noBeforeValue)),
                            afterValue: (json.data[parentRowIndex].entries[j].afterValue ? json.data[parentRowIndex].entries[j].afterValue : (this.noAfterValue))
                        };
                        json.data.splice(currentRowIndex + 1, 0, childRow);
                    }
                } else if (json.data[parentRowIndex].entries) {
                    for (let m = 0; m < json.data[parentRowIndex].entries.length; m++) {
                        if (json.data[parentRowIndex].entries[m].attributeDisplayName === 'Prospect Status') {
                            json.data[parentRowIndex].entries.unshift(json.data[parentRowIndex].entries.splice(m, 1)[0]);
                        }
                    }

                    for (let j = 0; j < json.data[parentRowIndex].entries.length; j++, currentRowIndex++) {
                        const childRow = {
                            isChild: true,
                            parentRowId: i,
                            isOdd: j % 2 === 1,
                            button: null,
                            date: json.data[parentRowIndex].date,
                            time: json.data[parentRowIndex].time,
                            user: json.data[parentRowIndex].user,
                            modificationType: '',
                            operation: (json.data[parentRowIndex].entries[j].operation ? json.data[parentRowIndex].entries[j].operation : (this.operation)),
                            attributeDisplayName: json.data[parentRowIndex].entries[j].attributeDisplayName,
                            beforeValue: (json.data[parentRowIndex].entries[j].beforeValue ? json.data[parentRowIndex].entries[j].beforeValue : (this.noBeforeValue)),
                            afterValue: (json.data[parentRowIndex].entries[j].afterValue ? json.data[parentRowIndex].entries[j].afterValue : (this.noAfterValue))
                        };
                        json.data.splice(currentRowIndex + 1, 0, childRow);
                    }
                }
            }

            if (!parentRowCount) {
                globals.enableApp();
            }
        },

        /**
         * Assign data attributes to a DataTable row when it is created.
         *
         * @param {HTMLTableRowElement} row - The row to have data assigned to
         * @param {Object} rowData - The row data to assign to the row
         * @param {number} rowData.parentRowId - The parent row ID, useful for mapping children to parents (assigned to both parent and child rows)
         * @param {bool} rowData.isChild - Whether or not the row is a child
         * @param {bool} rowData.isOdd - Whether or not the row is odd relative to it's group (parents or children of same parent)
         */
        onDataTableCreateRow(row, rowData) {
            const $row = $(row);
            $row.attr('data-parent-row-id', rowData.parentRowId);
            $row.attr('data-is-child', rowData.isChild);
            $row.attr('data-is-odd', rowData.isOdd);
        },

        /**
         * Called after DataTables has done initial drawing.
         * Assigns proper classes and wires up buttons.
         */
        onDataTableDraw() {
            if (!this.isLoaded && (isOrderEntrySite || isQuotingSite)) {
                this.isLoaded = true;
            }

            // Remove default highlighting and update according to new rows
            const _this = this;
            this.$('tbody > tr').each(function() {
                const $row = $(this);
                $row.addClass('collapsed');
                $row.removeClass('odd even');
                if ($row.data('isOdd')) {
                    $row.addClass('odd');
                }
                else {
                    $row.addClass('even');
                }

                if ($row.data('isChild')) {
                    $row.addClass('child-row');
                }
                else {
                    $row.find('button.expand-collapse')
                        .on('click', _this.toggleRow.bind(_this, $row, $row.data('parentRowId')));
                }
            });
            globals.enableApp();
        },

        /**
         * Shows/hides a rows children.
         *
         * @param {jQuery} $row - The row element
         * @param {number} rowIndex - The row number
         * @param {Event} e - The button click's event
         */
        toggleRow($row, rowIndex, e) {
            e.preventDefault();
            const $childRows = $row.closest('tbody').find('tr.child-row[data-parent-row-id="' + rowIndex + '"]');
            if ($row.hasClass('collapsed')) {
                // The row is expanded - collapse it
                e.target.innerText = '-';
            }
            else {
                // The row is collapsed - expand it
                e.target.innerText = '+';
            }

            $row.toggleClass('collapsed');
            $childRows.toggleClass('collapsed');
        }
    });
}(westcon));
